// @ts-nocheck
import { createAsyncAction } from '../../../core/store/actionCreators';
import {
  ACTIVATE_CONTRACT,
  ADD_USERS_TO_CONTRACT,
  CLOSE_CONTRACT,
  CREATE_COMPANY,
  CREATE_CONTRACT,
  FETCH_COMPANIES,
  FETCH_COMPANY,
  FETCH_CONTRACT,
  FETCH_PRODUCTS,
  UPDATE_COMPANY,
} from './companyActionTypes';
import CompanyService from '../services/CompanyService';
import ContractService from '../services/ContractService';
import ProductService from '../../subscriptions/services/ProductService';

export const fetchCompanies = createAsyncAction(
  FETCH_COMPANIES,
  async (filterParams, sortParams, page, size) => {
    const { data } = await CompanyService.fetchCompanies(filterParams, sortParams, page, size);
    return data;
  }
);

export const fetchCompany = createAsyncAction(FETCH_COMPANY, async companyId => {
  const { data } = await CompanyService.fetchCompany(companyId);
  return data;
});

export const fetchContract = createAsyncAction(FETCH_CONTRACT, async contractId => {
  const { data } = await ContractService.fetchContract(contractId);
  return data;
});

export const fetchProducts = createAsyncAction(FETCH_PRODUCTS, async clientSegment => {
  const { data } = await ProductService.fetchCompanyProducts(clientSegment);
  return data?.products;
});

export const createCompany = createAsyncAction(CREATE_COMPANY, async companyData => {
  const { data } = await CompanyService.createCompany(companyData);
  return data;
});

export const updateCompany = createAsyncAction(UPDATE_COMPANY, async companyData => {
  const { data } = await CompanyService.updateCompany(companyData);
  return data;
});

export const searchCompanies = createAsyncAction(FETCH_COMPANIES, async filterParams => {
  const { data } = await CompanyService.searchCompanies(filterParams);
  return data;
});

export const createContract = createAsyncAction(CREATE_CONTRACT, async contractData => {
  const { data } = await ContractService.createContract(contractData);
  return data;
});

export const closeContract = createAsyncAction(CLOSE_CONTRACT, async (contractId, force) => {
  const { data } = await ContractService.closeContract(contractId, force);
  return data;
});

export const activateContract = createAsyncAction(
  ACTIVATE_CONTRACT,
  async (companyId, contractId) => {
    const { data } = await ContractService.activateContract(companyId, contractId);
    return data;
  }
);

export const addUsersToContract = createAsyncAction(
  ADD_USERS_TO_CONTRACT,
  async (companyId, contractId, userIds) => {
    const { data } = await ContractService.addUsersToContract(companyId, contractId, userIds);
    return data;
  }
);
